import { z } from 'zod';

export const startEnglishIqSessionV1RequestSchema = z.object({
  locale: z.string().min(2).max(16).optional(),
  turnstileToken: z.string().min(1).optional(),
  visitorId: z.string().min(1).optional(),
});

export type IStartEnglishIqSessionV1Request = z.infer<typeof startEnglishIqSessionV1RequestSchema>;
